module.exports = __webpack_public_path__ + "img/qr.fe5fa11b.jpg";